import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { MRT_TableInstance } from 'material-react-table';

const nextVariant = {
  value: 'fallback',
  fallback: 'value',
} as const;

export function ToggleUSDNativeButton<TData extends Record<string, any> = object>({
  table,
}: {
  table: MRT_TableInstance<TData>;
}) {
  const variant = table.getState().displaySettings?.fallbackedTotalUSDVariant || 'value';
  const handleChange = () => {
    table.setState(state => ({
      ...state,
      displaySettings: {
        ...state.displaySettings,
        fallbackedTotalUSDVariant: nextVariant[variant],
      },
    }));
  };

  const titleTooltip = variant === 'value' ? 'Show native currencies' : 'Show in dollars';

  return (
    <Tooltip title={titleTooltip}>
      <IconButton onClick={handleChange}>
        {variant === 'value' ? <AttachMoneyIcon /> : <MoneyOffIcon />}
      </IconButton>
    </Tooltip>
  );
}
